import * as E from "~/renderer/web-components/element";

export class Flexbox extends E.SFMLElement {
  constructor() {
    super();
  }
}
customElements.define("sfml-flexbox", Flexbox);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/layout/flexbox.ts